"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.betaKey = exports.leagueRank = exports.unitName = exports.maybeCharId = exports.charId = exports.userId = undefined;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _withProps = require("recompose/withProps");

var _withProps2 = _interopRequireDefault(_withProps);

var _compose = require("recompose/compose");

var _compose2 = _interopRequireDefault(_compose);

var _assert = require("@swarm2/assert");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function maybeUrlParam(props, key) {
  return _lodash2.default.get(props, "match.params." + key);
}
function urlParam(props, key) {
  return (0, _assert.assertDefined)(maybeUrlParam(props, key), key);
}
function urlProp(key) {
  return (0, _withProps2.default)(function (props) {
    return _defineProperty({}, key, urlParam(props, key));
  });
}
function maybeUrlProp(key) {
  return (0, _withProps2.default)(function (props) {
    return _defineProperty({}, key, maybeUrlParam(props, key));
  });
}

var userId = exports.userId = urlProp("userId");
var charId = exports.charId = urlProp("charId");
var maybeCharId = exports.maybeCharId = maybeUrlProp("charId");
var unitName = exports.unitName = urlProp("unitName");
var rankName = urlProp("rankName");
var league = urlProp("league");
var leagueRank = exports.leagueRank = (0, _compose2.default)(league, rankName);
var betaKey = exports.betaKey = urlProp("betaKey");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/containers/util/urls.js
// module id = 48
// module chunks = 0